// extracted by mini-css-extract-plugin
module.exports = {"message":"Message_message__jdmZT"};